export const CONTAINER_CLASS = 'g2-tooltip';
export const TITLE_CLASS = 'g2-tooltip-title';
export const LIST_CLASS = 'g2-tooltip-list';
export const LIST_ITEM_CLASS = 'g2-tooltip-list-item';
export const MARKER_CLASS = 'g2-tooltip-marker';
export const VALUE_CLASS = 'g2-tooltip-value';
export const NAME_CLASS = 'g2-tooltip-name';
export const CROSSHAIR_X = 'g2-tooltip-crosshair-x';
export const CROSSHAIR_Y = 'g2-tooltip-crosshair-y';
